var _path, _rect, _rect2, _path2, _path3, _path4, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _path5, _path6, _path7, _rect29, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 165,
    viewBox: "0 0 180 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.033 136.174C154.081 136.174 170.333 133.535 170.333 130.279C170.333 127.024 154.081 124.385 134.033 124.385C113.985 124.385 97.7333 127.024 97.7333 130.279V130.279C97.7333 131.903 98.2285 135.973 96.7044 136.531C94.9888 137.159 94.0103 137.884 94.0103 138.656C94.0103 141.055 103.456 143 115.108 143C126.759 143 136.205 141.055 136.205 138.656C136.205 137.952 135.391 137.287 133.945 136.698C133.699 136.598 133.768 136.174 134.033 136.174V136.174Z",
    fill: "#F8F8F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.4899,
    y: 79.2671,
    width: 150.388,
    height: 3.9838,
    fill: "#D8D8D9",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4899,
    y: 118.607,
    width: 150.388,
    height: 3.9838,
    fill: "#D8D8D9",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.74 134.942H51.4258V138.775C51.4258 139.517 50.8246 140.118 50.0829 140.118C49.3412 140.118 48.74 139.517 48.74 138.775V134.942Z",
    fill: "white",
    stroke: "#D8D8D9",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.477 134.942H116.163V138.775C116.163 139.517 115.561 140.118 114.82 140.118C114.078 140.118 113.477 139.517 113.477 138.775V134.942Z",
    fill: "white",
    stroke: "#D8D8D9",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165.266 129.558V63.4519C165.266 62.9216 164.966 62.4369 164.492 62.1997L162.504 61.2058C162.11 61.0087 161.646 61.0087 161.252 61.2058L159.264 62.1997C158.79 62.4369 158.49 62.9216 158.49 63.4519V129.558C158.49 130.332 159.117 130.958 159.89 130.958H163.866C164.639 130.958 165.266 130.332 165.266 129.558Z",
    fill: "white",
    stroke: "#D8D8D9",
    strokeWidth: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 151.013,
    y: 66.4177,
    width: 7.7838,
    height: 63.5448,
    rx: 1.4,
    fill: "white",
    stroke: "#D8D8D9",
    strokeWidth: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 54.7157,
    y: 67.2177,
    width: 3.1838,
    height: 61.9448,
    stroke: "black",
    strokeWidth: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 144.539,
    y: 66.4177,
    width: 6.7838,
    height: 63.5448,
    rx: 1.4,
    fill: "white",
    stroke: "#D8D8D9",
    strokeWidth: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48.242,
    y: 67.2177,
    width: 3.1838,
    height: 61.9448,
    stroke: "black",
    strokeWidth: 0.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 138.065,
    y: 66.4177,
    width: 6.7838,
    height: 63.5448,
    rx: 1.4,
    fill: "white",
    stroke: "#D8D8D9",
    strokeWidth: 0.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9683,
    y: 66.4177,
    width: 6.7838,
    height: 63.5448,
    rx: 1.4,
    fill: "white",
    stroke: "#D8D8D9",
    strokeWidth: 0.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 131.592,
    y: 66.4177,
    width: 6.7838,
    height: 63.5448,
    rx: 1.4,
    fill: "white",
    stroke: "#D8D8D9",
    strokeWidth: 0.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 32.4947,
    y: 66.4177,
    width: 6.7838,
    height: 63.5448,
    rx: 1.4,
    fill: "white",
    stroke: "#D8D8D9",
    strokeWidth: 0.8
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 125.118,
    y: 66.4177,
    width: 6.7838,
    height: 63.5448,
    rx: 1.4,
    fill: "white",
    stroke: "#D8D8D9",
    strokeWidth: 0.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 26.021,
    y: 66.4177,
    width: 6.7838,
    height: 63.5448,
    rx: 1.4,
    fill: "white",
    stroke: "#D8D8D9",
    strokeWidth: 0.8
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 118.644,
    y: 66.4177,
    width: 6.7838,
    height: 63.5448,
    rx: 1.4,
    fill: "white",
    stroke: "#D8D8D9",
    strokeWidth: 0.8
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5473,
    y: 66.4177,
    width: 6.7838,
    height: 63.5448,
    rx: 1.4,
    fill: "white",
    stroke: "#D8D8D9",
    strokeWidth: 0.8
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 114.971,
    y: 67.2177,
    width: 3.1838,
    height: 61.9448,
    stroke: "black",
    strokeWidth: 0.8
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 13.0737,
    y: 66.4177,
    width: 6.7838,
    height: 63.5448,
    rx: 1.4,
    fill: "white",
    stroke: "#D8D8D9",
    strokeWidth: 0.8
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 108.497,
    y: 67.2177,
    width: 3.1838,
    height: 61.9448,
    stroke: "black",
    strokeWidth: 0.8
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7521,
    y: 22.4,
    width: 73.3982,
    height: 113.236,
    rx: 4.6,
    fill: "white",
    stroke: "#D8D8D9",
    strokeWidth: 0.8
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 6.6,
    y: 66.4177,
    width: 6.7838,
    height: 63.5448,
    rx: 1.4,
    fill: "white",
    stroke: "#D8D8D9",
    strokeWidth: 0.8
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 122.636,
    y: 77.3732,
    width: 20.221,
    height: 14.2453,
    fill: "white",
    stroke: "#D8D8D9",
    strokeWidth: 0.8
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 126.024,
    y: 80.761,
    width: 14.4413,
    height: 1.49392,
    fill: "#F8F8F8"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 48.838,
    y: 25.9838,
    width: 66.2306,
    height: 57.2671,
    rx: 2,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3319,
    y: 87.7327,
    width: 3.9838,
    height: 26.3927,
    fill: "#ECECEC"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 58.2995,
    y: 89.7245,
    width: 22.9068,
    height: 1.49392,
    fill: "#ECECEC"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 58.2995,
    y: 100.68,
    width: 14.9392,
    height: 1.49392,
    fill: "#ECECEC"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 58.2995,
    y: 92.7124,
    width: 17.9271,
    height: 1.49392,
    fill: "#ECECEC"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 58.2995,
    y: 103.668,
    width: 11.4534,
    height: 1.49392,
    fill: "#ECECEC"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 58.2995,
    y: 108.648,
    width: 11.4534,
    height: 1.49392,
    fill: "#ECECEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.645 128.211C112.134 128.906 111.969 129.889 111.172 130.185C110.463 130.448 109.706 130.576 108.941 130.557C107.659 130.524 106.422 130.08 105.411 129.29C104.401 128.499 103.672 127.405 103.331 126.169C102.991 124.932 103.058 123.619 103.521 122.423C103.985 121.227 104.821 120.212 105.906 119.528C106.991 118.844 108.267 118.527 109.546 118.624C110.825 118.722 112.039 119.228 113.008 120.068C113.586 120.569 114.059 121.174 114.405 121.846C114.795 122.602 114.254 123.439 113.424 123.623V123.623C112.593 123.807 111.792 123.232 111.212 122.609C111.142 122.534 111.068 122.463 110.99 122.395C110.52 121.988 109.932 121.743 109.312 121.695C108.693 121.648 108.074 121.802 107.549 122.133C107.023 122.465 106.618 122.957 106.393 123.536C106.168 124.116 106.136 124.752 106.301 125.351C106.466 125.95 106.819 126.481 107.309 126.864C107.798 127.246 108.398 127.462 109.019 127.477C109.123 127.48 109.226 127.477 109.328 127.469C110.176 127.4 111.156 127.515 111.645 128.211V128.211Z",
    fill: "#ECECEC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.859 87.448C131.022 87.6799 130.967 88.0075 130.701 88.1062C130.465 88.1939 130.212 88.2364 129.957 88.23C129.53 88.2191 129.117 88.0711 128.781 87.8077C128.444 87.5443 128.201 87.1795 128.087 86.7673C127.974 86.3551 127.996 85.9173 128.151 85.5187C128.305 85.1201 128.584 84.7818 128.945 84.5538C129.307 84.3257 129.733 84.2201 130.159 84.2526C130.585 84.285 130.99 84.4537 131.313 84.7338C131.505 84.9009 131.663 85.1024 131.779 85.3264C131.908 85.5784 131.728 85.8576 131.451 85.9189V85.9189C131.175 85.9802 130.907 85.7883 130.714 85.5809C130.691 85.5559 130.666 85.532 130.64 85.5095C130.484 85.3738 130.288 85.292 130.081 85.2763C129.874 85.2606 129.668 85.3118 129.493 85.4222C129.318 85.5327 129.183 85.6967 129.108 85.8898C129.033 86.083 129.022 86.2951 129.077 86.4949C129.132 86.6946 129.25 86.8714 129.413 86.999C129.576 87.1266 129.776 87.1984 129.983 87.2036C130.018 87.2045 130.052 87.2035 130.086 87.2008C130.369 87.1778 130.695 87.2161 130.859 87.448V87.448Z",
    fill: "#F8F8F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M134.501 85.1354C134.312 84.9239 133.981 84.903 133.824 85.1395C133.685 85.3496 133.587 85.5856 133.535 85.8354C133.448 86.2541 133.499 86.6895 133.679 87.0773C133.859 87.4651 134.159 87.7847 134.534 87.9888C134.91 88.193 135.341 88.2708 135.765 88.2109C136.188 88.151 136.581 87.9565 136.885 87.6561C137.189 87.3557 137.389 86.9654 137.454 86.5429C137.519 86.1204 137.447 85.6881 137.248 85.3099C137.129 85.0842 136.968 84.8849 136.776 84.7216C136.56 84.5379 136.248 84.65 136.125 84.9056V84.9056C136.002 85.1612 136.129 85.465 136.287 85.7003C136.306 85.7287 136.323 85.7582 136.339 85.7886C136.436 85.9719 136.471 86.1814 136.439 86.3861C136.408 86.5909 136.311 86.78 136.164 86.9255C136.016 87.0711 135.826 87.1653 135.621 87.1944C135.416 87.2234 135.207 87.1857 135.025 87.0868C134.843 86.9878 134.697 86.833 134.61 86.645C134.523 86.4571 134.498 86.2461 134.54 86.0433C134.547 86.0096 134.556 85.9764 134.566 85.9438C134.653 85.6739 134.69 85.347 134.501 85.1354V85.1354Z",
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 28,
    width: 65,
    height: 56
  }, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 50.5744,
    y: 28.2051,
    width: 63.9128,
    height: 55.2256,
    rx: 5,
    fill: "#F8F8F8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.699 74.1316H108.351V46.463H74.7279V62.0222H74.3805V46.115H108.699V74.1316Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.59 74.2676H108.381V46.0972H109.582L119.294 34.5548L128.6 46.2164V56.6462H128.253V46.3356L119.294 35.1111L109.74 46.4448H108.728V73.92H128.243L128.253 60.6493H128.6L128.59 74.2676Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.051 46.4777H128.383L119.329 35.1383L109.768 46.4777H73.511L71.9325 45.3547L83.3596 33.2401H99.0458V33.5879H83.5085L72.4587 45.305L73.6202 46.1299H109.609L119.329 34.5818L128.552 46.1299H129.326L119.269 33.5879H105.072V33.2401H119.438L119.488 33.3097L130.051 46.4777Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2796 76.5342H91.6529V73.9502H95.2796V76.5342ZM92.0016 76.1891H94.9309V74.2954H92.0016V76.1891Z",
    fill: "#D4EFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.782 76.5342H108.381V73.9502H128.772V76.5342H128.782ZM108.728 76.1891H128.425V74.2954H108.728V76.1891Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.813 76.5342H114.32V73.9502L115.865 73.9601V75.1929H116.804L116.813 76.5342ZM114.662 76.1891H116.471V75.5282H115.533V74.2954H114.672V76.1891H114.662Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.411 60.8033H108.381V56.6779H131.411V60.8033ZM108.729 60.4603H131.063V57.0208H108.729V60.4603Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.827 60.8939H108.381V56.6779H111.827V60.8939ZM108.728 60.5443H111.48V57.0275H108.728V60.5443Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8422 58.3099H78.5966V51.0111H88.8422V58.3099ZM78.9448 57.9619H88.494V51.3691H78.9448V57.9619Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.437 58.3099H94.1916V51.0111H104.437V58.3099ZM94.5397 57.9619H104.089V51.3691H94.5397V57.9619V57.9619Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.256 76.5343H94.9169V61.8007H104.246V76.5343H104.256ZM95.2635 76.1861H103.899V62.1489H95.2635V76.1861Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.829 77.7583H91.6529V76.2169H110.829V77.7583ZM91.9997 77.4102H110.482V76.565H91.9997V77.4102Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.776 77.7583H110.512V76.2169H130.776V77.7583V77.7583ZM110.859 77.4034H130.429V76.5718H110.859V77.4034Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0155 74.2675H80.7726V62.7073H92.0155V74.2675ZM81.1218 73.9205H91.6664V63.0543H81.1218V73.9205Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1353 77.7583H66.991V62.7073H81.1353V77.7583ZM67.3377 77.4103H80.7887V63.0552H67.3377V77.4103Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0155 76.5342H80.7726V73.9502H92.0155V76.5342ZM81.1215 76.1891H91.6667V74.2954H81.1215V76.1891Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0155 77.7583H80.7726V76.2169H92.0155V77.7583ZM81.1215 77.4102H91.6667V76.565H81.1215V77.4102Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7916 76.5342H66.991V73.9502H69.0311V74.2954H67.3263V76.1891H68.7916V76.5342Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1353 76.5342H78.6873V76.1891H80.7856V74.2954H78.6873V73.9502H81.1353V76.5342Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1353 77.7583H66.991V76.2169H69.0993V76.565H67.3375V77.4102H80.7889V76.3959H81.1353V77.7583Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0155 63.07H81.4073V61.8007H92.0155V63.07ZM81.7559 62.7059H91.6669V62.1648H81.7559V62.7059Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.77 63.07H66.4924V61.8007H81.77V63.07ZM66.84 62.7059H81.4223V62.1648H66.84V62.7059Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.354 41.9442H98.8157V31.1547H101.354V41.9442ZM99.1711 41.5965H100.999V31.5024H99.1711V41.5965Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.308 41.9442H100.992V31.1745L105.208 31.1547V37.1841L101.308 41.9442ZM101.338 31.5216V41.3591L104.861 37.0552V31.5018L101.338 31.5216Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.48 31.472H98.6797V30.0667H101.49V31.472H101.48ZM99.0261 31.128H101.144V30.4106H99.0261V31.128Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.344 31.472H101.082V30.0667H105.344V31.472ZM101.434 31.128H104.992V30.4106H101.434V31.128Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.914 77.6676H68.9857V69.2355H78.914V77.6676ZM69.3457 77.3213H78.574V69.5819H69.3457V77.3213V77.3213Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9755 68.8728H82.8127V65.8807H89.9755V68.8728ZM83.1614 68.5272H89.6268V66.2264H83.1614V68.5272V68.5272Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.299 45.4803H72.1591V45.1327H109.14L119.175 33.2854L119.443 33.5138L109.299 45.4803Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1539 69.4169H73.7458V77.5317H74.1539V69.4169Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9272 71.8649H69.2124V72.1822H73.9272V71.8649Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9272 74.8116H69.2124V75.1743H73.9272V74.8116Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9007 51.2377H83.5381V58.1738H83.9007V51.2377Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6155 54.5471H78.6873V54.9098H88.6155V54.5471Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5864 51.2377H99.2237V58.1738H99.5864V51.2377Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.301 54.5471H94.3729V54.9098H104.301V54.5471Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7677 62.0273H99.405V76.353H99.7677V62.0273Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.12 66.062H95.0529V66.4247H104.12V66.062Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4655 72.6356H52.4387V72.9983H59.4655V72.6356Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4655 73.4969H52.4387V73.8143H59.4655V73.4969Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4655 74.3129H52.4387V74.6755H59.4655V74.3129Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5082 75.3556H51.5773V75.7183H60.5082V75.3556Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7987 72.1368H53.4814V77.441H53.7987V72.1368Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5135 72.1368H58.1508V77.441H58.5135V72.1368Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2137 64.8834C64.2436 65.06 64.2137 65.2072 64.1639 65.3446C64.1141 65.482 64.0344 65.5997 63.9347 65.7076C63.8351 65.8156 63.7255 65.9039 63.5959 65.9627C63.4664 66.0216 63.317 66.0707 63.1376 66.0609C63.1675 65.8842 63.2273 65.7567 63.297 65.6389C63.3668 65.5212 63.4365 65.4231 63.5262 65.325C63.6159 65.2367 63.7055 65.1483 63.8151 65.0699C63.9247 65.011 64.0443 64.9423 64.2137 64.8834Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3993 64.7473C62.5473 64.8371 62.6399 64.9569 62.7139 65.0766C62.7879 65.2064 62.8249 65.3461 62.8527 65.4858C62.8712 65.6255 62.8712 65.7752 62.8435 65.9149C62.8157 66.0546 62.7602 66.2043 62.6491 66.334C62.5381 66.1943 62.4825 66.0646 62.4363 65.9448C62.39 65.8151 62.3622 65.6953 62.3437 65.5656C62.3252 65.4359 62.316 65.3161 62.3252 65.1764C62.316 65.0567 62.3437 64.917 62.3993 64.7473Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5963 66.7421H61.2336V77.5316H61.5963V66.7421Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5576 68.7168L61.2639 71.2898L61.5745 71.4459L62.8682 68.8729L62.5576 68.7168Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3923 71.9102C59.0266 71.9102 57.1082 69.9921 57.1082 67.6268C57.1082 66.4044 57.9232 63.3832 58.7383 61.0377C59.5136 58.7818 60.607 56.0885 61.3923 56.0885C62.1775 56.0885 63.2709 58.7818 64.0462 61.0377C64.8513 63.3832 65.6763 66.4044 65.6763 67.6268C65.6664 69.9921 63.748 71.9102 61.3923 71.9102ZM61.3923 56.4363C61.1139 56.4363 60.2591 57.6886 59.0663 61.157C58.132 63.8602 57.4561 66.5932 57.4561 67.6367C57.4561 69.8033 59.2254 71.5723 61.3923 71.5723C63.5592 71.5723 65.3285 69.8033 65.3285 67.6367C65.3285 66.5932 64.6525 63.8602 63.7182 61.157C62.5254 57.6886 61.6706 56.4363 61.3923 56.4363Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.579 77.3956H44.3692V77.7583H153.579V77.3956Z",
    fill: "#E6E6E6"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.2e422fd693d5958468979a616ebdaa70.svg";
export { ForwardRef as ReactComponent };